import * as actions from './actions'

const baseURL = process.env.VUE_APP_API_URL_BASE

// initial state
const state = {
  inspectionSettlement: {
    ts_id: '',
    otoken: '',
    popinfoid: '',
    ss_cd: '',
    OrderID: '', // ショップ発行の取引識別 ID
    Amount: 0, // 利用金額
    DateTime: '', // リンク決済を呼び出した日時情報 yyyyMMddhhmmss 書式
    RetURL: baseURL + '/v1/inspection_settlement_linktype_plus', // 決済結果戻し先 URL
    CancelURL: baseURL + '/v1/inspection_settlement_linktype_plus_cancel',
    CompleteURL: baseURL + '/v1/inspection_settlement_linktype_plus', // 決済結果戻し先 URL
    UseCredit: '1', // クレジット決済利用フラグ
    JobCd: 'CAPTURE', // 処理区分 CHECK:有効性チェック CAPTURE:即時売上 AUTH:仮売上
    inspectionID: '', // 車検ID
    version: '',
    appVersion: '',
    platform: '',
    osVersion: ''
  }
}

// getters
const getters = {
  inspectionSettlement: (state, getters) => {
    return state.inspectionSettlement
  }
}

// mutations
const mutations = {
  SET_INSPECTION_SETTLEMENT (state, data) {
    state.inspectionSettlement = data
  }
}

// actions
// const actions = {
//   async setEstimate (context) {
//     const result = await estimate.get()
//     context.commit('SET_ESTIMATE', result.data)
//   }
// }

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
